const SNACKBAR_TYPES = Object.freeze({
    INFO: 'INFO',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS'
});

export default SNACKBAR_TYPES;
